import React, {FC, PropsWithChildren} from 'react';

import {cn} from '@bem-react/classname';
import {Text} from '@gravity-ui/uikit';

import {QuestionInfoProps} from './QuestionInfo.types';

import './QuestionInfo.scss';

const cnQuestionInfo = cn('QuestionInfo');

const QuestionInfo: FC<PropsWithChildren<QuestionInfoProps>> = ({label, info, children}) => {
    return (
        <div className={cnQuestionInfo()}>
            <div className={cnQuestionInfo('Header')}>
                <Text className={cnQuestionInfo('Label')} variant="body-2" as="h3">
                    {label}
                </Text>
                <Text className={cnQuestionInfo('Count')} variant="body-2" color="secondary">
                    {info}
                </Text>
            </div>
            {children}
        </div>
    );
};
export default QuestionInfo;
